import React from 'react';
import { SectionHeading } from './SectionHeading';
import { channel } from '../data/channel';
import { formatViews, videoUrl } from '../utils/video';
import type { Video } from '../types/video';
interface VideoArchiveProps {
  videos: Video[];
}
export function VideoArchive({
  videos
}: VideoArchiveProps) {
  const byYear = videos.reduce<Record<string, Video[]>>((acc, v) => {
    const year = v.publishedAt.slice(0, 4);
    (acc[year] ??= []).push(v);
    return acc;
  }, {});
  const years = Object.keys(byYear).sort((a, b) => Number(b) - Number(a));
  return <section id="archive" aria-labelledby="archive-title" className="scroll-mt-20 border-t border-line py-20 md:py-28" data-id="element-171" data-mp="10fub1gnqfu3s">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-172" data-mp="15edxrja5h9x7">
        <SectionHeading id="archive-title" title="Усі походи та подорожі" subtitle={`Повний архів відео — ${videos.length} випусків від Карпат до Альп.`} link={{
        href: `${channel.url}/videos`,
        label: 'Відкрити на YouTube'
      }} data-id="element-173" data-mp="15f708822td9j" />

        <div className="mt-10 grid gap-x-12 gap-y-10 lg:grid-cols-2" data-id="element-174" data-mp="3nm73t5iw3wyo">
          {years.map(year => <div key={year} data-id="element-175" data-mp="3invvx0c5nwj3">
              <h3 className="font-display text-lg font-semibold text-muted" data-id="element-176" data-mp="3iqrt2mg6ih6h">{year}</h3>
              <ul className="mt-3 divide-y divide-line border-t border-line" data-id="element-177" data-mp="1e7ks7ebwd0n">
                {byYear[year].map(video => <li key={video.id} data-id="element-178" data-mp="34wr4ummusckd">
                    <a href={videoUrl(video)} target="_blank" rel="noopener noreferrer" className="group flex items-baseline justify-between gap-4 py-3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ember" data-id="element-179" data-mp="34xsgotbp1335">
                      <span className="min-w-0 text-sm font-semibold leading-snug text-paper transition-colors duration-150 group-hover:text-ember md:text-base" data-id="element-180" data-mp="2m5zmivkw1btu">
                        {video.title}
                      </span>
                      <span className="shrink-0 whitespace-nowrap text-sm tabular-nums text-muted" data-id="element-181" data-mp="36usgdbnw5r6m">
                        {video.duration} · {formatViews(video.views, false)}
                      </span>
                    </a>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}